import { useState, useEffect, useCallback } from "react";
import { format } from "date-fns";

import { Link, useNavigate } from "react-router-dom";
import { CalendarIcon, ClockIcon } from "../../shared/svgIcon";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAppointments, getUpcomingAppointments } from "../../lib/api";

export function ScheduleCard(props) {
  let navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setLoading] = useState(true);

  
  const settings = {
    dots: true,
    infinite: true,
    // autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const fetchAppointments = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const query_parameters = {
        // "user_id": "654894739c4dd83f4ba079d0",
        // "organization_id": "654515714b1c8f293f4c014b",
        consumer_id: patientId,
      };
      const res = await getUpcomingAppointments(query_parameters);
      // console.log(res, "res");
      const appointments = res?.data?.result;
      setAppointments(appointments || []);
      setLoading(false);
      // console.log(appointments, "ecg");
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const startCall = (e) => {
    sessionStorage.setItem("selectedAppointment", JSON.stringify(e));
    navigate("/videoCall");
  };

  const gotoSchedule = () => {
    navigate("/schedule");
  };
  

  useEffect(() => {
    fetchAppointments();
  }, []);
  
  return (
    <>
      {appointments?.length == 0 && (
        <div className="bg-indigo-200 p-4 rounded-3xl col-span-6  relative overflow-hidden">
          <img
            src="../../../images/setappoinment.png"
            className=" absolute bottom-0 right-0"
            alt="setappoinment"
          />
          <div className="z-10 relative">
            <div className="text-lg font-bold leading-5 mb-2">
              Set
              <br />
              Appointment
            </div>
            <p className="leading-4 text-xs">
              Schedule or manages your <br />
              appointments
            </p>
            <Link
              to="/schedule"
              className=" rounded-full px-3 py-1 bg-white text-black text-sm font-semibold mt-10 inline-block "
            >
              Schedule appointment
            </Link>
          </div>
        </div>
      )}
      {appointments?.length > 0 && (
        <div className="col-span-6 relative overflow-hidden">
          <Slider {...settings}>
            {appointments.map((e, index) => (
              <div
                key={index}
                className="bg-indigo-200 p-4 rounded-3xl col-span-6 relative overflow-hidden"
              >
                <img
                  src="../../../images/upcomingAppointment.png"
                  className=" absolute bottom-0 right-0"
                  alt="setappoinment"
                />
                <div className="z-10 relative">
                  <div className="text-xl font-bold leading-5 mb-2">
                  Upcoming Appointment
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                  <CalendarIcon width={'45px'} height={'50px'} className='text-primary' />
                  <p className="leading-4 ">
                    <p className="font-semibold text-base text-primary">
                      {e?.user?.profile?.name_prefix || "Dr."}{" "}
                      {e?.user?.profile?.first_name}{" "}
                      {e?.user?.profile?.middle_name}{" "}
                      {e?.user?.profile?.last_name}
                    </p>
                    <p className="font-semibold text-sm flex  items-center">
                      {format(new Date(e.start_time), "PP")}{" "}
                    </p>
                    <div className="font-semibold text-sm flex  items-center">
                      <span> {format(new Date(e.start_time), "h:mm a")}</span>{" "}
                      <span className="px-1">-</span>
                      <span> {format(new Date(e.end_time), "h:mm a")}</span>
                    </div>
                  </p>
                  </div>
                  
                  <div className="flex justify-between gap-2 flex-col min-[430px]:flex-row"> 
                  <button
                    className=" rounded-full h-9 px-4 py-1 bg-primary text-white text-sm font-semibold mt-5 min-[430px]:mb-3 inline-block "
                    onClick={() => startCall(e)}
                  >
                    Start Consultation
                  </button>
                  <button
                    className=" rounded-full h-9 px-4 py-1 bg-white text-black text-sm font-semibold min-[430px]:mt-5 mb-3 inline-block "
                    onClick={() => gotoSchedule()}
                  >
                    Schedule Appointment
                  </button>
                  </div>
                  
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
}
